var map = {
	"./_base/base-dropdown/base-dropdown.js": 3245,
	"./_catalog/catalog-item-single/catalog-item-single.js": 7337,
	"./_catalog/catalog.js": 4372,
	"./_forms/form-request/form-request.js": 3788,
	"./_navigation/navigation.js": 5476,
	"./_order/order.js": 9515,
	"./_pages/page-index/index-slider/index-slider.js": 5546,
	"./_pagination/pagination.js": 7258,
	"./init.js": 2486
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1594;